import { render, staticRenderFns } from "./FAQListItem.vue?vue&type=template&id=60f28ff6"
import script from "./FAQListItem.vue?vue&type=script&lang=js"
export * from "./FAQListItem.vue?vue&type=script&lang=js"
import style0 from "./FAQListItem.vue?vue&type=style&index=0&id=60f28ff6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports